import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
/**
 * Tracks the difference between old and new versions of {@link values}.
 *
 * @param values The values to diff.
 * @param isValid Whether the values are currently considered valid. They can be invalid when the data is being loaded,
 *  which is often the case in endpoint hooks.
 * @param keyIteratee The selector used to check if two elements are equal.
 */
export var useDiff = function (values, isValid, keyIteratee) {
    var knownValues = useRef(undefined);
    var _a = useState({ added: [], updated: [], removed: [] }), diff = _a[0], setDiff = _a[1];
    useEffect(function () {
        if (isValid) {
            if (knownValues.current === undefined) {
                knownValues.current = values;
                setDiff({ added: [], updated: [], removed: [] });
            }
            else {
                var oldByKey_1 = _.keyBy(knownValues.current, keyIteratee);
                var newByKey_1 = _.keyBy(values, keyIteratee);
                var added_1 = [];
                var updated_1 = [];
                var removed_1 = [];
                _.forEach(newByKey_1, function (value, key) {
                    if (key in oldByKey_1) {
                        if (!_.isEqual(value, oldByKey_1[key])) {
                            updated_1.push(value);
                        }
                    }
                    else {
                        added_1.push(value);
                    }
                });
                _.forEach(oldByKey_1, function (value, key) {
                    if (!(key in newByKey_1)) {
                        removed_1.push(value);
                    }
                });
                knownValues.current = values;
                setDiff({
                    added: added_1,
                    updated: updated_1,
                    removed: removed_1,
                });
            }
        }
    }, [values, isValid]);
    return diff;
};
